import { useState } from 'react'

import { Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'

import HavLogo from 'assets/svg/login/hav-logo.svg'
import { slides } from 'constants/mocks'

import * as S from './styles'

type AuthLayoutProps = {
  children?: React.ReactNode
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [infoOpacity, setInfoOpacity] = useState(1)

  const handleTransparent = () => {
    if (slides.length > 1) setInfoOpacity(0)
  }

  return (
    <S.Wrapper>
      <S.SwiperPanel>
        <S.InfoContainer opacity={infoOpacity}>
          <S.InfoTitle>{slides[currentSlide].title}</S.InfoTitle>
          <S.InfoDescription>{slides[currentSlide].description}</S.InfoDescription>
        </S.InfoContainer>
        <Swiper
          modules={[Pagination]}
          onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
          onTouchEnd={() => setInfoOpacity(1)}
          onTouchMove={handleTransparent}
          pagination={{ clickable: true, type: 'bullets' }}
          slidesPerView={1}
        >
          {slides.map((slide, index) => {
            return (
              <SwiperSlide key={`slide-${index}`}>
                <S.ImageGradient>
                  <S.SwiperImage src={slide.image} />
                </S.ImageGradient>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </S.SwiperPanel>
      <S.FormPanel>
        <S.Logo alt="Logomarca Havaianas" src={HavLogo} />
        {children}
      </S.FormPanel>
    </S.Wrapper>
  )
}
